import { render, staticRenderFns } from "./PhotoPermission.vue?vue&type=template&id=8124dc5c&scoped=true&"
import script from "./PhotoPermission.vue?vue&type=script&lang=js&"
export * from "./PhotoPermission.vue?vue&type=script&lang=js&"
import style0 from "./PhotoPermission.vue?vue&type=style&index=0&id=8124dc5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8124dc5c",
  null
  
)

export default component.exports